import { useState, useCallback, useEffect } from 'react';
import * as S from './styles';
import EditCreateMontagensModal from './CreateEdit';
import { useAuth } from '../../../hooks/auth';
import { FlexboxGrid, List } from 'rsuite';
import api from '../../../services/api';
import { CustomButton } from '../../../components/CustomButton';
import { CopyModal } from './CopyModal';
import { ListItem } from './ListItem';
import { EditSequence } from './EditSequence';
import { FaLightbulb } from 'react-icons/fa';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { Spacer } from '../../../components/Spacer';
import { toastError } from '../../../toasts';

const Montagens = ({
  product,
  setProduct,
  montagensProduto,
  setMontagensProduto,
}) => {
  const { id_empresa } = useAuth();
  const { theme } = useCustomTheme();
  const [montagem, setMontagem] = useState(null);
  const [montagens, setMontagens] = useState([]);
  const [modalCreate, setModalCreate] = useState(false);
  const [modalCopy, setModalCopy] = useState(false);
  const [modalSequence, setModalSequence] = useState(false);

  const listarMontagens = useCallback(() => {
    api
      .get(`/montagem-prato/listar/${id_empresa}`)
      .then((response) => {
        setMontagens(response.data);
      })
      .catch((error) => {
        toastError('Erro ao listar');
      });
  }, [id_empresa]);

  const listarMontagensProduto = useCallback(() => {
    api
      .get(`/produto-montagens/listar/${product?.Id}`)
      .then((response) => {
        setMontagensProduto(response.data);
      })
      .catch((error) => {
        toastError('Erro ao listar');
      });
  }, [product.Id]);

  const handleUseMounting = (value) => {
    setProduct((prev) => ({
      ...prev,
      MontagemPrato: value ?? !prev.MontagemPrato,
    }));
  };

  function handleCreateModal() {
    setModalCreate((prev) => !prev);
    setMontagem(null);
  }

  function handleEditModal(_montagem) {
    setMontagem(_montagem);
    setModalCreate((prev) => !prev);
  }

  const handleMontagensProduto = useCallback(
    (newState) => {
      setMontagensProduto(newState);
    },
    [montagensProduto],
  );

  const closeCreateEdit = () => {
    setMontagem(null);
    setModalCreate(false);
  };

  useEffect(() => {
    listarMontagens();
    listarMontagensProduto();
  }, [listarMontagens, listarMontagensProduto]);

  return (
    <>
      <FlexboxGrid style={{ gap: '10px' }}>
        <div>
          <FaLightbulb color={theme.colors.textSecondary} size={12} />
        </div>
        <div>
          <S.MountingExplanation>
            Com montagem de pratos é possivel criar seleções para compor o
            produto como por Exemplo:
          </S.MountingExplanation>
          <S.MountingExplanation>
            "Selecione o pão" ou "Selecione o ponto"
          </S.MountingExplanation>
        </div>
      </FlexboxGrid>
      <S.ContainerMounting>
        <FlexboxGrid
          justify="end"
          style={{ marginBottom: '20px', gap: '10px' }}
        >
          <CustomButton onClick={() => handleUseMounting()}>
            {!!product?.MontagemPrato
              ? 'Não Usar Montagem de Pratos'
              : 'Usar Montagem de Pratos'}
          </CustomButton>

          <Spacer flex={1} />

          {!!product.MontagemPrato && (
            <>
              <CustomButton onClick={() => setModalCopy(true)}>
                Copiar montagens
              </CustomButton>
              {montagensProduto.length > 1 && (
                <CustomButton onClick={() => setModalSequence(true)}>
                  Editar Sequencia
                </CustomButton>
              )}
              <CustomButton onClick={handleCreateModal}>Cadastrar</CustomButton>
            </>
          )}
        </FlexboxGrid>

        <S.Info>
          As montagens marcados serão usados pelo produto como opção de
          escolha, na ordem selecionada
        </S.Info>
      </S.ContainerMounting>

      {!!product.MontagemPrato && (
        <List bordered>
          {montagens.map((item) => (
            <ListItem
              key={item.Id}
              item={item}
              product={product}
              handleEditModal={handleEditModal}
              listarMontagensProduto={listarMontagensProduto}
              montagemProduto={montagensProduto?.find(
                (mont) => mont?.IdMontagemPrato === item?.Id,
              )}
            />
          ))}
        </List>
      )}

      <CopyModal
        key={`copy-modal-${product?.Id}`}
        product={product}
        open={modalCopy}
        onClose={() => setModalCopy(false)}
        listarMontagensProduto={listarMontagensProduto}
      />
      <EditCreateMontagensModal
        open={modalCreate}
        montagem={montagem}
        setMontagens={setMontagens}
        close={closeCreateEdit}
        id_empresa={id_empresa}
      />

      <EditSequence
        open={modalSequence}
        onClose={() => setModalSequence(false)}
        montagensProduto={montagensProduto}
        handleMontagensProduto={handleMontagensProduto}
      />
    </>
  );
};

export default Montagens;
